const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "-0.5 -0.5 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0001ac",
    d: "M -0.5,-0.5 C 340.833,-0.5 682.167,-0.5 1023.5,-0.5C 1023.5,340.833 1023.5,682.167 1023.5,1023.5C 682.167,1023.5 340.833,1023.5 -0.5,1023.5C -0.5,682.167 -0.5,340.833 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00b265",
    d: "M 192.5,454.5 C 156.833,454.5 121.167,454.5 85.5,454.5C 85.5,438.833 85.5,423.167 85.5,407.5C 105.632,387.868 125.632,368.035 145.5,348C 161.163,347.5 176.83,347.333 192.5,347.5C 192.5,383.167 192.5,418.833 192.5,454.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 348.5,454.5 C 384.004,454.168 419.337,454.502 454.5,455.5C 418.833,455.5 383.167,455.5 347.5,455.5C 347.5,529.167 347.5,602.833 347.5,676.5C 311.5,676.5 275.5,676.5 239.5,676.5C 239.333,586.833 239.5,497.166 240,407.5C 259.833,387.667 279.667,367.833 299.5,348C 315.497,347.5 331.497,347.333 347.5,347.5C 347.168,383.337 347.502,419.004 348.5,454.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 454.5,455.5 C 419.337,454.502 384.004,454.168 348.5,454.5C 383.632,418.868 418.965,383.368 454.5,348C 501.838,349.35 535.338,371.517 555,414.5C 558.349,423.246 560.682,432.246 562,441.5C 562.5,519.833 562.667,598.166 562.5,676.5C 526.5,676.5 490.5,676.5 454.5,676.5C 454.5,602.833 454.5,529.167 454.5,455.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 937.5,675.5 C 887.003,676.499 836.336,676.832 785.5,676.5C 756.535,647.035 727.368,617.701 698,588.5C 668.667,617.833 639.333,647.167 610,676.5C 609.5,566.834 609.333,457.167 609.5,347.5C 645.5,347.5 681.5,347.5 717.5,347.5C 717.333,370.169 717.5,392.836 718,415.5C 740.5,393 763,370.5 785.5,348C 836.5,347.333 887.5,347.333 938.5,348C 883.653,402.68 828.986,457.514 774.5,512.5C 828.521,567.188 882.854,621.521 937.5,675.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0d7c7f",
    d: "M 85.5,407.5 C 85.5,423.167 85.5,438.833 85.5,454.5C 121.167,454.5 156.833,454.5 192.5,454.5C 192.5,454.833 192.5,455.167 192.5,455.5C 192.167,455.5 191.833,455.5 191.5,455.5C 155.833,455.5 120.167,455.5 84.5,455.5C 84.1703,439.325 84.5036,423.325 85.5,407.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 191.5,455.5 C 191.833,455.5 192.167,455.5 192.5,455.5C 192.5,529.167 192.5,602.833 192.5,676.5C 156.833,676.5 121.167,676.5 85.5,676.5C 85.3333,638.165 85.5,599.832 86,561.5C 121.368,526.299 156.535,490.965 191.5,455.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7f7fd7",
    d: "M 937.5,675.5 C 938.043,675.56 938.376,675.893 938.5,676.5C 887.335,677.831 836.335,677.831 785.5,676.5C 836.336,676.832 887.003,676.499 937.5,675.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInkIcon);
export default __webpack_public_path__ + "static/media/ink_icon.d66d08bd.svg";
export { ForwardRef as ReactComponent };